/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-04 18:41:01
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-14 15:54:17
 * @FilePath: /unifyxp-v2-store-portal/src/layout/Components/CollapseTrigger/Trigger.tsx
 */
import React from 'react';
import { Icon } from '@/src/tools/icon';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';

const Trigger = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  ///useClearSalesChannel();
  const { open } = props;
  return (
    <div className={css.collapse}>
      <Icon
        className={css.icon}
        type={!open ? 'iconcollapse-right' : 'iconcollapse-left'}
      />
      {open && (
        <span className={css.text}>{getI18n('general.collapsemenu')}</span>
      )}
    </div>
  );
};
export default Trigger;
